// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"p4-z"};